import React, { FC } from 'react'
import { DataSourcesType, ExpandedDataType, FirstDataType } from './types'
import expandedRowRender from './expandedRowRender'
import { Col, Row, Switch, Table, TableColumnsType } from 'antd'
import { ColorPicker, theme, ColorPickerProps } from 'antd-v5'
import {
  generate,
  green,
  presetPalettes,
  red,
  yellow,
} from '@ant-design/colors'
import { useCalendarEvents } from 'lib/hooks/calendar'

// カラーピッカーのパレット
type Presets = Required<ColorPickerProps>['presets'][number]
const genPresets = (presets = presetPalettes) =>
  Object.entries(presets).map<Presets>(([label, colors]) => ({ label, colors }))

// カレンダー表示設定コンポーネント
const CalendarSettingsTable: FC = () => {
  const { productsData, toggleDisplay, changeBgColor } = useCalendarEvents()
  const columns: TableColumnsType<FirstDataType> = [
    {
      title: '施設名',
      dataIndex: 'storeName',
      key: 'storeName',
    },
  ]

  // カラーピッカーのパレット用
  const { token } = theme.useToken()
  const presets = genPresets({
    primary: generate(token.colorPrimary),
    red,
    green,
    yellow,
  })
  const panelRender: ColorPickerProps['panelRender'] = (
    _,
    { components: { Presets } }
  ) => (
    <Row wrap={false}>
      <Col>
        <Presets />
      </Col>
    </Row>
  )

  // 表示施設設定テーブル用の配列
  const products: DataSourcesType[] = productsData?.products.edges.map(
    (product) => {
      const expandedDataSources: ExpandedDataType[] =
        product.product.variants.edges.map((variant) => {
          const item = variant.variant
          return {
            key: item.id,
            variation: item.title.jaJp,
            display: (
              <>
                <Switch
                  checkedChildren="表示"
                  unCheckedChildren="非表示"
                  defaultChecked={item.displayCalendar}
                  onChange={(checked) =>
                    toggleDisplay(product.product.id, item.id, checked)
                  }
                />
              </>
            ),
            color: (
              <div className="flex justify-start gap-6">
                <ColorPicker
                  presets={presets}
                  defaultValue={item.colorCode}
                  onChangeComplete={(color) =>
                    changeBgColor(
                      product.product.id,
                      item.id,
                      color.toHexString()
                    )
                  }
                  panelRender={panelRender}
                />
              </div>
            ),
          }
        })

      return {
        firstDataSources: [
          {
            key: product.product.id,
            storeName: product.product.name.jaJp,
          },
        ],
        expandedDataSources,
      }
    }
  )

  if (!products) return <>データがありません。</>

  return (
    <>
      {products?.map((tableDataSource, index) => (
        <Table
          key={index}
          style={{ marginBottom: 24 }}
          columns={columns}
          expandable={{
            expandedRowRender: () =>
              expandedRowRender(tableDataSource.expandedDataSources),
            defaultExpandedRowKeys: ['0'],
          }}
          dataSource={tableDataSource.firstDataSources}
          pagination={false}
        />
      ))}
    </>
  )
}

export default CalendarSettingsTable
